export enum QueryKeys {
  USER_TRANSACTIONS = 'user_transactions',
  LATEST_PROPOSAL = 'latest-proposal',
  VAULTS = 'vaults',
  VAULT_PERFORMANCE = 'vault_performance',
  USER_POSITIONS = 'user_positions',
  USER_PORTFOLIO = 'user_portfolio',
  USER_PENDING_WITHDRAWALS = 'user_pending_withdrawals',
  POINTS_LEADERBOARD = 'points_leaderboard',
  POINTS_ACTIVITIES = 'points_activities',
  POINTS_OPPORTUNITIES = 'points_opportunities',
  POINTS_STATUS = 'points_status',
  USER_POINTS_ACTIVITY = 'user_points_activity',
  USER_POINTS_SUMMARY = 'user_points_summary',
  REFERRAL_SUMMARY = 'referral_summary',
  REFERRAL_INVITEES = 'referral_invitees',
}
